import { styled, lighten } from '@mui/material/styles';

const StyledTextButton = styled('button')(({ theme, disabled }) => ({
  fontSize: '1rem',
  backgroundColor: 'transparent',
  color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#33CCCC',
  padding: '4px 8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': disabled
    ? {}
    : {
        backgroundColor: lighten('#33CCCC', 0.8),
      },
  [theme.breakpoints.down('md')]: {
    padding: '2px 8px',
  },
  '& .MuiTypography-root': {
    color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#33CCCC',
  },
}));

export default StyledTextButton;
